<template>
  <div>
    <el-form :inline="true" style="margin-top:20px">
      <el-form-item>
        <el-button size="medium" @click="addPrice">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="index" label="序号" width="80" type="index">
      </el-table-column>
      <el-table-column prop="NAME" label="供应商名称">
      </el-table-column>
      <!-- <el-table-column prop="STATUS" label="状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.STATUS == 1">未报价</span>
                    <span v-if="scope.row.STATUS == 2">已报价</span>
                </template>
            </el-table-column> -->
      <el-table-column prop="action" label="操作">
        <template slot-scope="scope">
          <!-- <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button> -->
          <el-button type="text" size="small" @click="cancelMatch(scope.row)">取消匹配</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增模态框 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增匹配" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item label="供应商名称：">
          <el-select v-model="addForm.SUPPLIER_ID">
            <el-option v-for="(item, index) in supplierList" :key="index" :label="item.NAME" :value="item.SUPPLIER_ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitMatch">确认</el-button>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <!-- <div class="pagination_box" v-show="totalCount > 10">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="pageSize"
                layout="total,prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </div> -->
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      addForm: {
        SUPPLIER_NAME: '',
        SUPPLIER_ID: '',
      },
      addDialog: false,
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      supplierList: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getSupplierPrice();
    this.getSupplierList();
  },
  methods: {
    // 获取供应商比价列表
    getSupplierPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 16,
        // PAGESIZE: this.pageSize,
        // PAGEINDEX: this.currentPage -1,
        F_CAT_ID: Number(this.$route.params.id),
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = res;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增匹配关系
    addPrice() {
      this.addDialog = true;
    },
    // 获取供应商
    getSupplierList() {
      const params = {
        SERVICE_ID: '10001',
        OTYPE: 9,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        this.supplierList = result[0].list;
      })
        .catch((error) => {
          console.log(error);
        });
    },
    supplierSelect(item) {
      this.addForm.SUPPLIER_ID = item.ID;
    },
    checkValue() {
      if (!this.addForm.SUPPLIER_NAME) {
        this.addForm.SUPPLIER_ID = '';
      }
    },
    // 分页
    // handleCurrentChange (e) {
    //   this.currentPage = e
    //   this.getSupplierPrice()
    // },
    // 提交匹配
    submitMatch() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 17,
        F_CAT_ID: Number(this.$route.params.id),
        SUPPLIER_ID: this.addForm.SUPPLIER_ID,
      };
      if (!this.addForm.SUPPLIER_ID) {
        this.$message.show({ text: '请选择供应商', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '匹配成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.getSupplierPrice();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 查看
    detail(row) {
      this.$router.push({ path: `/t_supplierDetail/${row.RECORD_ID}`, params: { id: row.RECORD_ID } });
    },
    // 取消匹配
    cancelMatch(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 18,
        MATCH_ID: row.MATCH_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '取消成功', type: 'success' });
        this.getSupplierPrice();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.pagination_box {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/compareDetail.vue